import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

export const PATH_TEAMS = '/teams/';

const PATH_NEW_TEAM = `${PATH_TEAMS}new/`;

export const teamsRoutesConfig = createRouteConfig(
  {
    newTeam: {
      path: PATH_NEW_TEAM,
      generatePath: () => PATH_NEW_TEAM,
    },
    teams: {
      path: PATH_TEAMS,
      generatePath: () => PATH_TEAMS,
    },
  },
  PATH_TEAMS,
);
